const resources = {
  "en": {
    "taskEvents": {
      "title": "Task activity",
      "description": "Follow created, confirmed, and cancelled task history without leaving the user-facing app.",
      "filters": {
        "title": "Filter the activity feed",
        "description": "Narrow the feed by source, event status, or date range.",
        "source": {
          "label": "Source",
          "options": {
            "all": "All",
            "api": "API",
            "system": "System",
            "worker": "Worker",
            "forecast": "Forecast",
            "unknown": "Unknown"
          }
        },
        "status": {
          "label": "Status",
          "options": {
            "all": "All",
            "created": "Created",
            "confirmed": "Confirmed",
            "cancelled": "Cancelled",
            "unknown": "Unknown"
          }
        },
        "dateRange": "Date range",
        "refresh": "Refresh"
      },
      "summary": {
        "title": "Quick snapshot",
        "description": "See how much activity is in the current filtered scope before opening the full timeline.",
        "events": "Events",
        "sources": "Sources",
        "statuses": "Statuses",
        "countLabel": "{{label}}: {{count}}"
      },
      "statusLabels": {
        "pending": "Pending",
        "overdue": "Overdue",
        "processing": "Processing",
        "queued": "Queued",
        "scheduled": "Scheduled",
        "generated": "Generated",
        "failed": "Failed",
        "completed": "Completed",
        "done": "Done",
        "ready": "Ready",
        "unknown": "Unknown"
      },
      "graph": {
        "title": "Relationship graph",
        "description": "See how events in the current scope connect back to tasks and recurring schedules.",
        "empty": "No relationships found",
        "edgeLabels": {
          "eventToTask": "Event linked to task",
          "taskToRecurring": "Task linked to recurring schedule"
        }
      },
      "timeline": {
        "title": "Timeline",
        "description": "{{count}} events match the current filters.",
        "toTask": "Go to task",
        "createdAt": "Created at",
        "source": "Source",
        "task": "Task",
        "description": "Description",
        "goal": "Goal {{id}}",
        "contract": "Contract {{id}}",
        "amount": "Amount",
        "accountLabel": "account {{accountId}}",
        "scheduledFor": "Scheduled for",
        "recurringLabel": "Recurring:",
        "recurringFallback": "View schedule",
        "lastStatusLabel": "Last status:",
        "lastStatusFrom": "from {{source}}",
        "empty": "No events"
      },
      "timeline": {
        "title": "Timeline",
        "toTask": "Go to task",
        "createdAt": "Created at",
        "source": "Source",
        "task": "Task",
        "description": "Description",
        "goal": "Goal {{id}}",
        "contract": "Contract {{id}}",
        "amount": "Amount",
        "accountLabel": "account {{accountId}}",
        "scheduledFor": "Scheduled for",
        "recurringLabel": "Recurring:",
        "recurringFallback": "View schedule",
        "lastStatusLabel": "Last status:",
        "lastStatusFrom": "from {{source}}",
        "empty": "No events",
        "createdByWorker": "Worker created task (status: {{status}})"
      },
      "messages": {
        "loadFailed": "Failed to load task events log"
      },
      "placeholders": {
        "notAvailable": "—"
      }
    }
  },
  "uk": {
    "taskEvents": {
      "title": "Активність задач",
      "description": "Переглядайте історію створення, підтвердження та скасування задач без переходу в адмінські або технічні екрани.",
      "filters": {
        "title": "Відфільтруйте стрічку",
        "description": "Звузьте стрічку за джерелом, статусом події або діапазоном дат.",
        "source": {
          "label": "Джерело",
          "options": {
            "all": "Всі",
            "api": "API",
            "system": "Система",
            "worker": "Воркер",
            "forecast": "Прогноз",
            "unknown": "Невідомо"
          }
        },
        "status": {
          "label": "Статус",
          "options": {
            "all": "Всі",
            "created": "Створено",
            "confirmed": "Підтверджено",
            "cancelled": "Скасовано",
            "unknown": "Невідомо"
          }
        },
        "dateRange": "Діапазон дат",
        "refresh": "Оновити"
      },
      "summary": {
        "title": "Швидкий зріз",
        "description": "Подивіться обсяг подій у поточному фільтрі перед тим, як відкривати всю стрічку.",
        "events": "Події",
        "sources": "Джерела",
        "statuses": "Статуси",
        "countLabel": "{{label}}: {{count}}"
      },
      "statusLabels": {
        "pending": "В очікуванні",
        "overdue": "Прострочено",
        "processing": "Опрацьовується",
        "queued": "У черзі",
        "scheduled": "Заплановано",
        "generated": "Згенеровано",
        "failed": "Помилка",
        "completed": "Завершено",
        "done": "Готово",
        "ready": "Готовий",
        "unknown": "Невідомо"
      },
      "graph": {
        "title": "Зв’язки",
        "description": "Показує, як події в поточному фільтрі пов’язані із задачами та повторюваними графіками.",
        "empty": "Зв’язків не знайдено",
        "edgeLabels": {
          "eventToTask": "Подія пов’язана із задачею",
          "taskToRecurring": "Задача пов’язана з графіком"
        }
      },
      "timeline": {
        "title": "Стрічка",
        "description": "{{count}} подій відповідають поточним фільтрам.",
        "toTask": "Перейти до задач",
        "createdAt": "Створено",
        "source": "Джерело",
        "task": "Задача",
        "description": "Опис",
        "goal": "Ціль {{id}}",
        "contract": "Контракт {{id}}",
        "amount": "Сума",
        "accountLabel": "рахунок {{accountId}}",
        "scheduledFor": "Заплановано на",
        "recurringLabel": "Повторення:",
        "recurringFallback": "Переглянути графік",
        "lastStatusLabel": "Останній статус:",
        "lastStatusFrom": "від {{source}}",
        "empty": "Немає подій",
        "createdByWorker": "Воркер створив задачу (статус: {{status}})"
      },
      "messages": {
        "loadFailed": "Не вдалося завантажити події задач"
      },
      "placeholders": {
        "notAvailable": "—"
      }
    }
  }
};

export default resources;
